module.exports = "<div class=\"spinner-container\">\n  <mat-spinner class=\"loading-spinner\"></mat-spinner>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loading.component.html
// module id = ./src/app/shared/loading.component.html
// module chunks = main